import {AiChatCostType} from '@Libraries/ai-chat.library';

export const EDITABLE_LAYERS_BADGE_COUNT = String(AiChatCostType.MAKE_TEXT_EDITABLE_COST);

export enum EditMenuScreen {
  MAIN = 'main',
  EDIT = 'edit',
}

export interface GetEditSubmenuOptions {
  isMobile?: boolean;
}
